import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';
import { PasswordService } from 'src/app/core/services/password.service';

@Directive({
  selector: '[passwordPattern]',
  providers: [{ provide: NG_VALIDATORS, useExisting: PasswordPatternDirective, multi: true }]
})
export class PasswordPatternDirective implements Validator {

  constructor(private passwordService: PasswordService) { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.passwordService.validateCommonPassword()(control);
  }
}